import React, { useEffect, useState } from "react";
import Post from "../services/Post";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  message,
  Modal,
  Radio,
  Row,
  Skeleton,
  Spin,
  Table,
  Tabs,
  Tooltip,
  Typography,
} from "antd";
import io from "socket.io-client";
import Get from "../services/Get";

const RechargePlans = () => {
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("wallet");
  const [processing, setProcessing] = useState(false);
  const [cashbackApplied, setCashbackApplied] = useState(false);
  const [cashbackAmount, setCashbackAmount] = useState(0);

  const location = useLocation();
  const paysprintId = location.state.paysprintId;
  const user = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();

  const getPlans = () => {
    setLoading(true);
    Post.DthPlans(location.state.circle, paysprintId).then((res) => {
      if (res.data && res.data.info) {
        const filteredPlans = {
          "2G": res.data.info["2G"] || [],
          "3G/4G": res.data.info["3G/4G"] || [],
          COMBO: res.data.info["COMBO"] || [],
          FULLTT: res.data.info["FULLTT"] || [],
          Romaing: res.data.info["Romaing"] || [],
          SMS: res.data.info["SMS"] || [],
          TOPUP: res.data.info["TOPUP"] || [],
        };
        const allPlans = Object.values(filteredPlans).flat();

        setPlans({ All: allPlans, ...filteredPlans });
      } else {
        setPlans([]);
      }
      setLoading(false);
    });
  };

  const getCashbackDiscount = async () => {
    try {
      const res = await Get.CashbackDiscount(paysprintId);
      setCashbackAmount(res.data.cashback_amount);
    } catch (error) {
      console.error(error);
    }
  };

  const handleRecharge = (record) => {
    console.log(record);
    setSelectedPlan(record);
    setIsModalOpen(true);
  };

  const pay_now = async () => {
    try {
      let amount = selectedPlan.rs;

      if (cashbackApplied) {
        amount = selectedPlan.rs - (selectedPlan.rs * cashbackAmount / 100);
      }

      if (!amount) {
        message.error("Amount not found!");
        return null;
      }

      setProcessing(true);

      const res = await Post.PaymentLink(amount);
      console.log(res);

      const { paymentLink, order_id } = res.data;

      if (!paymentLink || !order_id) {
        message.error("Failed to retrieve payment link!");
        setProcessing(false);
        return null;
      }

      const paymentWindow = window.open(
        paymentLink,
        "_blank",
        "width=1000,height=800"
      );

      if (!paymentWindow) {
        message.error("Popup blocked! Please allow popups and try again.");
        setProcessing(false);
        return null;
      }

      let popupClosed = false;

      return new Promise((resolve, reject) => {
        const checkPopupClosed = setInterval(() => {
          if (paymentWindow.closed) {
            clearInterval(checkPopupClosed);
            popupClosed = true;
            message.error("Payment popup closed before completion!");
            setProcessing(false);
            reject(null);
          }
        }, 1000);

        const socket = io.connect("https://socket.rebatedekho.com");

        // Join a unique room for this payment
        socket.emit("join-room", order_id);

        socket.on("callback-event", (data) => {
          console.log("Payment callback received:", data);
          const parsedData = data;

          if (popupClosed) return;

          if (parsedData.STATUS_CODE === "RP000") {
            message.success(parsedData.ERROR_DESC);
            clearInterval(checkPopupClosed);
            socket.disconnect();
            resolve(parsedData.ORDER_ID);
          } else {
            message.error(parsedData.ERROR_DESC);
          }
        });
      });
    } catch (error) {
      message.error("Something went wrong while processing payment!");
      console.error(error);
      setProcessing(false);
      return null;
    }
  };

  const handlePayment = async () => {
    // Set processing state to true
    setProcessing(true);

    try {
      console.log({ paysprintId });

      if (paymentMethod === "online") {
        const payId = await pay_now();

        if (payId) {
          const send = {
            operator_id: paysprintId,
            latitude: 0.0,
            longitude: 0.0,
            method: paymentMethod,
            pay_id: payId,
            remark: `Your mobile recharge payment is successful`,
            description: `Your mobile recharge payment is successful`,
            status: `success`,
          };

          send.amount = selectedPlan.rs;
          send.canumber = location.state.phoneNumber;
          if (cashbackApplied) {
            send.cashback = selectedPlan.rs * cashbackAmount / 100;
          }

          console.log("data to send", send);

          const res = await Post.PayBill(send);
          console.log("res =====", res);

          if (res) {
            if (res.error) {
              console.log(res.error);
              message.error("Something went wrong");
              navigate(`/user/home`);
            } else {
              console.log("successss");
              message.success(res.data.message);
              navigate(`/user/eciept/${res.data.wallet_id}`);
            }
          }
        }
      } else {
        const send = {
          operator_id: paysprintId,
          latitude: 0.0,
          longitude: 0.0,
          method: paymentMethod,
        };

        send.amount = selectedPlan.rs;
        send.canumber = location.state.phoneNumber;

        if (cashbackApplied) {
          send.cashback = selectedPlan.rs * cashbackAmount / 100;
        }

        console.log("send data", send);

        const res = await Post.PayBill(send);
        console.log(res);

        if (res) {
          if (res.error) {
            console.log(res.error);
            message.error(res.error);
          } else {
            if (!res.data.status) {
              console.log(res);
              if (res.error) {
                console.log(res.error);
                message.error("Something went wrong");
                navigate(`/user/home`);
              } else {
                console.log(res.data?.message);
                message.error("Something went wrong");
                navigate(`/user/home`);
              }
            } else {
              console.log("successs!!!!");
              message.success(res.data.message);
              navigate(`/user/reciept/${res.data.wallet_id}`);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error in payment:", error);
      message.error(error);
    } finally {
      // Reset processing state
      setProcessing(false);
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    getPlans();
    getCashbackDiscount();
  }, []);

  const columns = [
    {
      title: "Price",
      dataIndex: "rs",
      key: "price",
      width: 100,
      responsive: ["md"],
      render: (text) => <span>₹ {text}</span>,
    },
    {
      title: "Description",
      dataIndex: "desc",
      key: "description",
      responsive: ["md"],
      render: (text) => (
        <span style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {text}
        </span>
      ),
    },
    {
      title: "Validity",
      dataIndex: "validity",
      key: "validity",
      responsive: ["md"],
    },
    {
      title: "Details",
      // dataIndex: "desc",
      key: "description",
      responsive: ["xs"],
      render: (data) => (
        <div>
          <span style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
            {data.desc}
          </span>
          <br />
          <Typography.Text
            strong
            style={{ whiteSpace: "normal", wordWrap: "break-word" }}
          >
            ₹ {data.rs}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button
          type="primary"
          style={{
            backgroundColor: "#a6cc43",
            borderColor: "#a6cc43",
            color: "#FFFFFF",
          }}
          onClick={() => handleRecharge(record)}
        >
          Recharge
        </Button>
      ),
    },
  ];

  const renderTable = (key) => {
    const data = plans[key] || [];
    return (
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={false}
        style={{ tableLayout: "auto" }}
      />
    );
  };

  return (
    <div className="layout-content">
      <Row className="mb-4" justify={"center"}>
        <Col xs={24} md={18} lg={18} xl={14}>
          <Spin spinning={loading}>
            <Card>
              <Tabs
                defaultActiveKey="All"
                items={Object.keys(plans).map((key) => ({
                  label: key,
                  key: key,
                  children: renderTable(key),
                }))}
              />
            </Card>
          </Spin>
        </Col>
      </Row>
      <Modal
        title="Pay Now"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <Card
          title="Recharge Details"
          bordered={true}
          style={{ width: "100%" }}
        >
          {/* Cashback Section */}
          {cashbackAmount > 0 && (
            <Row gutter={[12, 12]} className="mb-4">
              <Col span={24}>
                <Typography.Text strong>
                  Use cashback amount to get discount of ₹
                  {(selectedPlan?.rs * cashbackAmount) / 100}
                </Typography.Text>
              </Col>
              <Col span={12}>
                <Typography.Text type="secondary">
                  Cashback Balance: ₹{user.cashback_balance}
                </Typography.Text>
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                <Button
                  type="primary"
                  size="small"
                  className="form-btn"
                  onClick={() => setCashbackApplied(true)}
                  disabled={
                    loading ||
                    cashbackApplied ||
                    user.cashback_balance < (selectedPlan?.rs * cashbackAmount) / 100 ||
                    cashbackAmount < 1
                  }
                >
                  {cashbackApplied ? "Applied" : "Apply"}
                </Button>
              </Col>
            </Row>
          )}
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Typography.Text strong>Total Payable:</Typography.Text>
            </Col>
            <Col span={12}>
              {loading ? (
                <Skeleton.Input active={true} size="default" />
              ) : cashbackApplied ? (
                <div>
                  <Typography.Text
                    delete
                    style={{ color: "red", marginRight: 8 }}
                  >
                    ₹ {selectedPlan?.rs}
                  </Typography.Text>
                  <Typography.Text strong>
                    ₹{" "}
                    {selectedPlan?.rs -
                      (selectedPlan?.rs * cashbackAmount) / 100}
                  </Typography.Text>
                </div>
              ) : (
                <Typography.Text>₹ {selectedPlan?.rs}</Typography.Text>
              )}
            </Col>

            <Col span={12}>
              <Typography.Text strong>Validity:</Typography.Text>
            </Col>
            <Col span={12}>
              {loading ? (
                <Skeleton.Input active={true} size="default" />
              ) : (
                <Typography.Text>{selectedPlan?.validity}</Typography.Text>
              )}
            </Col>

            <Col span={12}>
              <Typography.Text strong>Discription:</Typography.Text>
            </Col>
            <Col span={12}>
              {loading ? (
                <Skeleton.Input active={true} size="default" />
              ) : (
                <Typography.Text>{selectedPlan?.desc}</Typography.Text>
              )}
            </Col>
          </Row>

          <Row>
            <Typography.Text strong className="mt-25">
              Select Payment Method:
            </Typography.Text>
          </Row>
          <Row>
            <Radio.Group
              onChange={(e) => setPaymentMethod(e.target.value)}
              value={paymentMethod}
              style={{ display: "block", margin: "20px 0" }}
            >
              <Radio value="online" disabled>
                Online Payment
              </Radio>
              <Radio value="wallet">Wallet</Radio>
            </Radio.Group>
            <Button
              className="form-btn"
              block
              onClick={handlePayment}
              disabled={loading || processing}
            >
              {processing ? <Spin size="small" /> : "Pay Now"}
            </Button>
            <Button
              className="back-btn"
              block
              onClick={() => setIsModalOpen(false)}
              disabled={loading || processing}
            >
              Close
            </Button>
          </Row>
        </Card>
      </Modal>
    </div>
  );
};

export default RechargePlans;
